export const MAILGUN_REGIONS = {
	US: 'US',
	EU: 'EU',
} as const;

export type MailgunRegion = (typeof MAILGUN_REGIONS)[keyof typeof MAILGUN_REGIONS];

export const MAILGUN_REGION_OPTIONS = [
	{ value: MAILGUN_REGIONS.US, label: 'US' },
	{ value: MAILGUN_REGIONS.EU, label: 'EU' },
];

export const DEFAULT_MAILGUN_REGION: MailgunRegion = MAILGUN_REGIONS.US;
